var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDust(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.615 15.885C2.155 15.885 1.771 15.731 1.463 15.423C1.15433 15.1143 1 14.73 1 14.27V1.88499H0V0.88499H4V0.11499H10V0.88499H14V1.88499H13V14.27C13 14.73 12.846 15.114 12.538 15.422C12.2293 15.7307 11.845 15.885 11.385 15.885H2.615ZM4.808 12.885H5.808V3.88499H4.808V12.885ZM8.192 12.885H9.192V3.88499H8.192V12.885Z",
    fill: "#4F4F4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDust);
export default __webpack_public_path__ + "static/media/dust.baf675c7a78ca4c011908aaa4677a752.svg";
export { ForwardRef as ReactComponent };